import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiResponse } from './api.service';

export interface StateDropdownDto {
  stateId: string;
  state: string;
  stateCode: string;
  displayLabel: string;
}

/** Read-only state list for Customer/Supplier dropdowns (data maintained in DB). */
@Injectable({ providedIn: 'root' })
export class StateService {
  private apiService = inject(ApiService);

  getDropdown(): Observable<ApiResponse<StateDropdownDto[]>> {
    return this.apiService.get<StateDropdownDto[]>('State/dropdown');
  }
}
